import { colors } from '@chillibean/component-library';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';

export const LoaderVariant = {
  CELL: 'cell',
  HEADER: 'header',
};

export function Loader(props) {
  const { variant } = props;

  const loaders = {
    [LoaderVariant.CELL]: (
      <ContentLoader
        backgroundColor={colors.grey.secondary}
        foregroundColor={colors.grey.secondaryAlpha('40')}
        height={56}
        speed={2}
        viewBox="0 0 110 56"
        width={110}
      >
        <rect height="5" rx="0" ry="0" width="1" x="70" y="126" />
        <rect height="56" rx="4" ry="4" width="110" x="0" y="0" />
        <rect height="35" rx="0" ry="0" width="0" x="48" y="7" />
      </ContentLoader>
    ),
    [LoaderVariant.HEADER]: (
      <ContentLoader
        backgroundColor={colors.grey.primaryAlpha('20')}
        foregroundColor={colors.grey.secondaryAlpha('40')}
        height={28.57}
        speed={2}
        viewBox="0 0 108 28.57"
        width={108}
      >
        <rect height="5" rx="0" ry="0" width="1" x="70" y="126" />
        <rect height="18" rx="4" ry="4" width="108" x="0" y="4" />
      </ContentLoader>
    ),
  };

  if (!Object.keys(loaders).includes(variant)) return null;

  return loaders[variant];
}

Loader.propTypes = {
  variant: PropTypes.oneOf(Object.values(LoaderVariant)).isRequired,
};
export default Loader;
